import React from "react";
import {
  Grid,
  Box,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

const AccountNumber = ({ formik, setTouched, lookup }) => {
  const handleChange = (e) => {
    setTouched(true);
    formik.handleChange(e);
  };

  const handleChecked = (e) => {
    if (e.target.value === "no") {
      //remove IBAN data
      formik.setFieldValue("IBANLength", 0);
      formik.setFieldValue("BBANLength", 0);
      formik.setFieldValue("IBANBranchPosition", "");
      formik.setFieldValue("IBANAccountPosition", "");
      formik.setFieldValue("IBANBranchPosition", "");

      //reset account number data
      formik.setFieldValue("accountLength", lookup.accountLength || 0);
      formik.setFieldValue("branchPosition", lookup.branchPosition || "");
      formik.setFieldValue("clientIdLength", lookup.clientIdLength || 0);
      formik.setFieldValue("nationalId", lookup.nationalId || "");
      formik.setFieldValue(
        "accountPositionInput",
        lookup.accountPositionInput || ""
      );
      formik.setFieldValue(
        "accountPositionOutput",
        lookup.accountPositionOutput || ""
      );
    } else if (e.target.value === "IBAN") {
      //remove account number data
      formik.setFieldValue("accountLength", 0);
      formik.setFieldValue("branchPosition", "");
      formik.setFieldValue("clientIdLength", 0);
      formik.setFieldValue("nationalId", "");
      formik.setFieldValue("accountPositionInput", "");
      formik.setFieldValue("accountPositionOutput", "");

      //reset IBAN data
      formik.setFieldValue("IBANLength", lookup?.IBANLength || 0);
      formik.setFieldValue("BBANLength", lookup?.BBANLength || 0);
      formik.setFieldValue(
        "IBANBranchPosition",
        lookup?.IBANBranchPosition || ""
      );
      formik.setFieldValue(
        "IBANAccountPosition",
        lookup?.IBANAccountPosition || ""
      );
      formik.setFieldValue(
        "IBANBranchPosition",
        lookup?.IBANBranchPosition || ""
      );
    } else {
      //return to original values from lookup
      formik.setFieldValue("IBANLength", lookup?.IBANLength || 0);
      formik.setFieldValue("BBANLength", lookup?.BBANLength || 0);
      formik.setFieldValue(
        "IBANBranchPosition",
        lookup?.IBANBranchPosition || ""
      );
      formik.setFieldValue(
        "IBANAccountPosition",
        lookup?.IBANAccountPosition || ""
      );
      formik.setFieldValue(
        "IBANBranchPosition",
        lookup?.IBANBranchPosition || ""
      );

      formik.setFieldValue("accountLength", lookup?.accountLength || 0);
      formik.setFieldValue("branchPosition", lookup?.branchPosition || "");
      formik.setFieldValue("clientIdLength", lookup?.clientIdLength || 0);
      formik.setFieldValue("nationalId", lookup?.nationalId || "");
      formik.setFieldValue(
        "accountPositionInput",
        lookup?.accountPositionInput || ""
      );
      formik.setFieldValue(
        "accountPositionOutput",
        lookup?.accountPositionOutput || ""
      );
    }
  };
  return (
    <Grid
      container
      direction="column"
      rowSpacing="16px"
      justifyContent="flex-start"
      sx={{
        background: "#ffffff",
        borderRadius: "6px",
        border: "1px solid #E7E9EF",
        padding: "20px 30px 36px 30px",
      }}
    >
      <Grid item>
        <Typography
          sx={{
            color: "#050D2E",
            fontSize: "1.125rem",
            fontWeight: 550,
            marginBottom: "8px",
          }}
        >
          Account Number/IBAN
        </Typography>
        <RadioGroup
          row
          name="noOrIBAN"
          value={formik.values.noOrIBAN}
          onChange={handleChange}
        >
          <FormControlLabel
            value="no"
            onChange={handleChecked}
            control={<Radio />}
            label="Account No."
          />
          <FormControlLabel
            value="IBAN"
            onChange={handleChecked}
            control={<Radio />}
            label="IBAN"
          />
          <FormControlLabel
            value="both"
            onChange={handleChecked}
            control={<Radio />}
            label="Both"
          />
        </RadioGroup>
      </Grid>

      {formik.values.noOrIBAN !== "IBAN" && (
        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "flex-start", gap: "16px" }}
        >
          <Box>
            <Typography
              sx={{
                color: "#050D2E",
                fontSize: ".875rem",
                fontWeight: 550,
                lineHeight: "21px",
                marginBottom: "5px",
              }}
            >
              National ID
            </Typography>
            <TextField
              disabled={formik.values.noOrIBAN === "IBAN"}
              name="nationalId"
              value={formik.values.nationalId}
              onChange={handleChange}
              error={
                formik.touched.nationalId && Boolean(formik.errors.nationalId)
              }
              helperText={formik.touched.nationalId && formik.errors.nationalId}
              sx={{
                width: "360px",
                height: "36px",
                "& .MuiInputBase-root": { height: "36px" },
                "& .MuiOutlinedInput": { height: "36px" },
                ...(formik.errors.nationalId && { marginBottom: "10px" }),
              }}
            />
          </Box>
          <Box>
            <Typography
              sx={{
                color: "#050D2E",
                fontSize: ".875rem",
                fontWeight: 550,
                lineHeight: "21px",
                marginBottom: "5px",
              }}
            >
              Account Length
            </Typography>
            <TextField
              disabled={formik.values.noOrIBAN === "IBAN"}
              name="accountLength"
              value={formik.values.accountLength}
              onChange={handleChange}
              error={
                formik.touched.accountLength &&
                Boolean(formik.errors.accountLength)
              }
              helperText={
                formik.touched.accountLength && formik.errors.accountLength
              }
              sx={{
                width: "180px",
                height: "36px",
                "& .MuiInputBase-root": { height: "36px" },
                "& .MuiOutlinedInput": { height: "36px" },
                ...(formik.errors.accountLength && { marginBottom: "10px" }),
              }}
            />
          </Box>
        </Grid>
      )}

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "flex-start", gap: "16px" }}
      >
        {formik.values.noOrIBAN !== "IBAN" && (
          <Box>
            <Typography
              sx={{
                color: "#050D2E",
                fontSize: ".875rem",
                fontWeight: 550,
                lineHeight: "21px",
                marginBottom: "5px",
              }}
            >
              Account Position - Input
            </Typography>
            <TextField
              disabled={formik.values.noOrIBAN === "IBAN"}
              name="accountPositionInput"
              value={formik.values.accountPositionInput}
              onChange={handleChange}
              error={
                formik.touched.accountPositionInput &&
                Boolean(formik.errors.accountPositionInput)
              }
              helperText={
                formik.touched.accountPositionInput &&
                formik.errors.accountPositionInput
              }
              sx={{
                width: "360px",
                height: "36px",
                "& .MuiInputBase-root": { height: "36px" },
                "& .MuiOutlinedInput": { height: "36px" },
                ...(formik.errors.accountPositionInput && {
                  marginBottom: "10px",
                }),
              }}
            />
          </Box>
        )}

        {formik.values.noOrIBAN !== "no" && (
          <>
            <Box>
              <Typography
                sx={{
                  color: "#050D2E",
                  fontSize: ".875rem",
                  fontWeight: 550,
                  lineHeight: "21px",
                  marginBottom: "5px",
                }}
              >
                IBAN Length
              </Typography>
              <TextField
                disabled={formik.values.noOrIBAN === "no"}
                name="IBANLength"
                value={formik.values.IBANLength}
                onChange={handleChange}
                error={
                  formik.touched.IBANLength && Boolean(formik.errors.IBANLength)
                }
                helperText={
                  formik.touched.IBANLength && formik.errors.IBANLength
                }
                sx={{
                  width: "180px",
                  height: "36px",
                  "& .MuiInputBase-root": { height: "36px" },
                  "& .MuiOutlinedInput": { height: "36px" },
                  ...(formik.errors.IBANLength && { marginBottom: "30px" }),
                }}
              />
            </Box>{" "}
            <Box>
              <Typography
                sx={{
                  color: "#050D2E",
                  fontSize: ".875rem",
                  fontWeight: 550,
                  lineHeight: "21px",
                  marginBottom: "5px",
                }}
              >
                BBAN/RIB Length
              </Typography>
              <TextField
                disabled={formik.values.noOrIBAN === "no"}
                name="BBANLength"
                value={formik.values.BBANLength}
                onChange={handleChange}
                error={
                  formik.touched.BBANLength && Boolean(formik.errors.BBANLength)
                }
                helperText={
                  formik.touched.BBANLength && formik.errors.BBANLength
                }
                sx={{
                  width: "180px",
                  height: "36px",
                  "& .MuiInputBase-root": { height: "36px" },
                  "& .MuiOutlinedInput": { height: "36px" },
                  "& .MuiFormHelperText-root": {
                    width: "max-content",
                  },
                  ...(formik.errors.BBANLength && { marginBottom: "10px" }),
                }}
              />
            </Box>
          </>
        )}
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "flex-start", gap: "16px" }}
      >
        {formik.values.noOrIBAN !== "IBAN" && (
          <Box>
            <Typography
              sx={{
                color: "#050D2E",
                fontSize: ".875rem",
                fontWeight: 550,
                lineHeight: "21px",
                marginBottom: "5px",
              }}
            >
              Account Position - Output
            </Typography>
            <TextField
              disabled={formik.values.noOrIBAN === "IBAN"}
              name="accountPositionOutput"
              value={formik.values.accountPositionOutput}
              onChange={handleChange}
              error={
                formik.touched.accountPositionOutput &&
                Boolean(formik.errors.accountPositionOutput)
              }
              helperText={
                formik.touched.accountPositionOutput &&
                formik.errors.accountPositionOutput
              }
              sx={{
                width: "360px",
                height: "36px",
                "& .MuiInputBase-root": { height: "36px" },
                "& .MuiOutlinedInput": { height: "36px" },
                ...(formik.errors.accountPositionOutput && {
                  marginBottom: "10px",
                }),
              }}
            />
          </Box>
        )}
        {formik.values.noOrIBAN !== "no" && (
          <>
            <Box>
              <Typography
                sx={{
                  color: "#050D2E",
                  fontSize: ".875rem",
                  fontWeight: 550,
                  lineHeight: "21px",
                  marginBottom: "5px",
                }}
              >
                IBAN Branch Position
              </Typography>
              <TextField
                disabled={formik.values.noOrIBAN === "no"}
                name="IBANBranchPosition"
                value={formik.values.IBANBranchPosition}
                onChange={handleChange}
                error={
                  formik.touched.IBANBranchPosition &&
                  Boolean(formik.errors.IBANBranchPosition)
                }
                helperText={
                  formik.touched.IBANBranchPosition &&
                  formik.errors.IBANBranchPosition
                }
                sx={{
                  width: "180px",
                  height: "36px",
                  "& .MuiInputBase-root": { height: "36px" },
                  "& .MuiOutlinedInput": { height: "36px" },
                  ...(formik.errors.IBANBranchPosition && {
                    marginBottom: "10px",
                  }),
                }}
              />
            </Box>
            <Box>
              <Typography
                sx={{
                  color: "#050D2E",
                  fontSize: ".875rem",
                  fontWeight: 550,
                  lineHeight: "21px",
                  marginBottom: "5px",
                }}
              >
                IBAN Account Position
              </Typography>
              <TextField
                disabled={formik.values.noOrIBAN === "no"}
                name="IBANAccountPosition"
                value={formik.values.IBANAccountPosition}
                onChange={handleChange}
                error={
                  formik.touched.IBANAccountPosition &&
                  Boolean(formik.errors.IBANAccountPosition)
                }
                helperText={
                  formik.touched.IBANAccountPosition &&
                  formik.errors.IBANAccountPosition
                }
                sx={{
                  width: "180px",
                  height: "36px",
                  "& .MuiInputBase-root": { height: "36px" },
                  "& .MuiOutlinedInput": { height: "36px" },
                  ...(formik.errors.IBANAccountPosition && {
                    marginBottom: "10px",
                  }),
                }}
              />
            </Box>
          </>
        )}
      </Grid>

      {formik.values.noOrIBAN !== "IBAN" && (
        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "flex-start", gap: "16px" }}
        >
          <Box>
            <Typography
              sx={{
                color: "#050D2E",
                fontSize: ".875rem",
                fontWeight: 550,
                lineHeight: "21px",
                marginBottom: "5px",
              }}
            >
              Branch Length
            </Typography>
            <TextField
              disabled={formik.values.noOrIBAN === "IBAN"}
              name="branchLength"
              value={formik.values.branchLength}
              onChange={handleChange}
              error={
                formik.touched.branchLength &&
                Boolean(formik.errors.branchLength)
              }
              helperText={
                formik.touched.branchLength && formik.errors.branchLength
              }
              sx={{
                width: "180px",
                height: "36px",
                "& .MuiInputBase-root": { height: "36px" },
                "& .MuiOutlinedInput": { height: "36px" },
                ...(formik.errors.branchLength && { marginBottom: "10px" }),
              }}
            />
          </Box>
          <Box>
            <Typography
              sx={{
                color: "#050D2E",
                fontSize: ".875rem",
                fontWeight: 550,
                lineHeight: "21px",
                marginBottom: "5px",
              }}
            >
              Branch Position
            </Typography>
            <TextField
              disabled={formik.values.noOrIBAN === "IBAN"}
              name="branchPosition"
              value={formik.values.branchPosition}
              onChange={handleChange}
              error={
                formik.touched.branchPosition &&
                Boolean(formik.errors.branchPosition)
              }
              helperText={
                formik.touched.branchPosition && formik.errors.branchPosition
              }
              sx={{
                width: "180px",
                height: "36px",
                "& .MuiInputBase-root": { height: "36px" },
                "& .MuiOutlinedInput": { height: "36px" },
                ...(formik.errors.branchPosition && { marginBottom: "10px" }),
              }}
            />
          </Box>
          <Box>
            <Typography
              sx={{
                color: "#050D2E",
                fontSize: ".875rem",
                fontWeight: 550,
                lineHeight: "21px",
                marginBottom: "5px",
              }}
            >
              Client ID Length
            </Typography>
            <TextField
              disabled={formik.values.noOrIBAN === "IBAN"}
              name="clientIdLength"
              value={formik.values.clientIdLength}
              onChange={handleChange}
              error={
                formik.touched.clientIdLength &&
                Boolean(formik.errors.clientIdLength)
              }
              helperText={
                formik.touched.clientIdLength && formik.errors.clientIdLength
              }
              sx={{
                width: "180px",
                height: "36px",
                "& .MuiInputBase-root": { height: "36px" },
                "& .MuiOutlinedInput": { height: "36px" },
                ...(formik.errors.clientIdLength && { marginBottom: "10px" }),
              }}
            />
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default AccountNumber;
